import { Component } from 'react'
import { observer } from 'mobx-react'

import * as h from 'h'
import Labels from 'components/Labels'

import StandardContent from 'components/Popout/StandardContent'
import SocialPane from 'components/Popout/SocialPane'
import { ShareButtons } from 'components/SocialMedia'
import Dates from 'containers/NewsEvents/Dates'

import styles from './styles.scss'

@observer(['UiStore'])
export default class StoryView extends Component {
  render () {
    const { element } = this.props
    const { title, image, type, content, tags, location } = element

    const brand = type === 'news' ? 'success' : 'info'

    const locationLines = location && location.split('\n').reduce((acc, locationString) =>
      locationString ? [...acc, locationString, h.br()] : acc, [])

    const right = type === 'news' ? (
      h.h(Labels, {
        labels: tags.map(tag => (
          { brand: 'default', content: tag }
        ))
      })
    ) : (
      h.div(null,
        h.h(Dates, { story: element, location }),
        locationLines && h.address(h.ca('small'), ...locationLines))
    )

    const preContent = this.props.UiStore.windowWidth < 800 && h.h(ShareButtons)

    return h.div(h.ca(styles.storyView),
      h.h(StandardContent, {
        title,
        labels: [
          { brand, content: type === 'news' ? 'News Story' : 'Event' }
        ],
        right,
        preContent,
        content,
        image: image.details
      }),
      h.h(SocialPane, {url: window.location.href, text: title})
    )
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/StoryView/index.js